/* eslint-disable */
import createIcon from '../createIcon';

const IconComputer = createIcon({
  name: 'icon-computer',
  content: '<title>ic_电脑</title><defs><rect id="icon-computer-a" x="0" y="0" width="16" height="16"/></defs><g stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1655.000000, -5907.000000)"><g transform="translate(498.000000, 4920.000000)"><g transform="translate(111.000000, 987.000000)"><g transform="translate(1046.000000, 0.000000)"><mask id="icon-computer-b" fill="currentColor"><use xlink:href="#icon-computer-a"/></mask><use fill="currentColor" opacity="0" xlink:href="#icon-computer-a"/><path d="M16,14 L16,15 L0,15 L0,14 L16,14 Z M15,1 L15,12 L1,12 L1,1 L15,1 Z M14,2 L2,2 L2,11 L14,11 L14,2 Z" fill="currentColor" fill-rule="nonzero" mask="url(#icon-computer-b)"/></g></g></g></g></g>',
  width: 16,
  height: 16
}, 'Icon');
export default IconComputer;
